// Field types: text | textarea | number | bool | select | image | images | lines | paras | objects | date
const t = (key, label, extra = {}) => ({ key, label, type: "text", ...extra });
const ta = (key, label) => ({ key, label, type: "textarea" });
const num = (key, label) => ({ key, label, type: "number" });
const img = (key, label) => ({ key, label, type: "image" });
const lines = (key, label) => ({ key, label, type: "lines" });
const bi = (key, label, type = "text") => [{ key: `${key}_en`, label: `${label} (EN)`, type }, { key: `${key}_bn`, label: `${label} (BN)`, type }];

export const COLLECTIONS = {
  packages: {
    title: "Hajj & Umrah Packages",
    singular: "Package",
    listTitle: (x) => x.name_en,
    listSub: (x) => `${x.type} · ${x.tier} · ${x.currency === "BDT" ? "৳" : "$"}${Number(x.price || 0).toLocaleString("en-IN")}`,
    listImage: (x) => x.image,
    fields: [
      t("id", "ID (URL-safe, unique)", { hint: "e.g. hajj-2027-category-a" }),
      t("slug", "Slug (used in /package/slug)"),
      { key: "type", label: "Type", type: "select", options: ["hajj", "umrah"] },
      t("tier", "Tier / Category"),
      num("year", "Season year"),
      ...bi("name", "Name"),
      num("price", "Price"),
      { key: "currency", label: "Currency", type: "select", options: ["BDT", "USD"] },
      ...bi("price_note", "Price note"),
      t("duration", "Duration (days, e.g. 10 or 37–42)"),
      num("rating", "Rating (0-5)"),
      { key: "featured", label: "Featured on home page", type: "bool" },
      img("image", "Cover image"),
      t("makkah_hotel", "Makkah hotel"),
      t("makkah_dist", "Makkah hotel distance"),
      t("madinah_hotel", "Madinah hotel"),
      t("madinah_dist", "Madinah hotel distance"),
      ...bi("room", "Room sharing"),
      ...bi("flight", "Flight info"),
      ...bi("tagline", "Tagline"),
      ...bi("includes", "Inclusions (one per line)", "lines"),
      ...bi("notes", "Notes (one per line)", "lines"),
      { key: "stays", label: "Accommodation plan (Hajj)", type: "objects", fields: [...bi("city", "City"), ...bi("days", "Days"), ...bi("desc", "Description", "textarea")] },
    ],
  },
  tours: {
    title: "Halal Tours",
    singular: "Tour",
    listTitle: (x) => x.name_en,
    listSub: (x) => `$${x.price} · ${x.duration} days`,
    listImage: (x) => x.image,
    fields: [t("id", "ID (unique)"), ...bi("name", "Name"), num("price", "Price (BDT)"), num("duration", "Duration (days)"), img("image", "Image"), ...bi("desc", "Description", "textarea")],
  },
  blogs: {
    title: "Blog Posts",
    singular: "Post",
    listTitle: (x) => x.title_en,
    listSub: (x) => `${x.category_en} · ${x.date}`,
    listImage: (x) => x.image,
    fields: [
      t("id", "ID (unique)"), t("slug", "Slug (used in /blog/slug)"), ...bi("category", "Category"),
      { key: "date", label: "Date", type: "date" }, t("author", "Author"), img("image", "Cover image"),
      ...bi("title", "Title"), ...bi("excerpt", "Excerpt", "textarea"), ...bi("body", "Body (one paragraph per line)", "lines"),
    ],
  },
  testimonials: {
    title: "Testimonials",
    singular: "Testimonial",
    listTitle: (x) => x.name,
    listSub: (x) => `${x.location_en} · ${x.rating}★`,
    fields: [t("name", "Name"), ...bi("location", "Location"), num("rating", "Rating (1-5)"), ...bi("text", "Review", "textarea")],
  },
  gallery: {
    title: "Gallery",
    singular: "Photo",
    listTitle: (x) => x.en,
    listSub: (x) => x.cat,
    listImage: (x) => x.src,
    fields: [
      img("src", "Photo"),
      { key: "cat", label: "Category", type: "select", options: ["makkah", "madinah", "pilgrims", "halal"] },
      t("en", "Caption (EN)"), t("bn", "Caption (BN)"),
      { key: "tall", label: "Tall (portrait) card", type: "bool" },
    ],
  },
  team: {
    title: "Scholars & Team",
    singular: "Member",
    listTitle: (x) => x.n_en,
    listSub: (x) => x.r_en,
    listImage: (x) => x.image,
    fields: [img("image", "Photo"), ...bi("n", "Name"), ...bi("r", "Role / Title"), ...bi("d", "Qualification / Department")],
  },
  partners: {
    title: "Partners & Airlines",
    singular: "Partner",
    listTitle: (x) => x.name,
    listSub: () => "",
    listImage: (x) => x.logo,
    fields: [t("name", "Name"), img("logo", "Logo (optional)")],
  },
};

export const SETTINGS_SECTIONS = [
  { title: "Contact & Office", fields: [t("person", "Contact person"), t("phone", "Phone (display)"), t("phone2", "Phone (dial / WhatsApp number)"), t("email", "Email"), t("whatsapp", "WhatsApp link (https://wa.me/880...)"), t("facebook", "Facebook page URL"), ...bi("address", "Address"), ...bi("hours", "Office hours"), t("mapEmbed", "Google Maps embed URL")] },
  { title: "Branding", fields: [img("logo", "Logo (leave empty for default)")] },
  { title: "Statistics", fields: [num("stats.pilgrims", "Happy pilgrims"), num("stats.success", "Success rate (%)"), num("stats.rating", "Client rating"), num("stats.years", "Years of experience")] },
  { title: "Site Images", fields: [{ key: "images.heroSlides", label: "Home hero slides", type: "images" }, img("images.aboutMain", "About main"), img("images.aboutSecondary", "About secondary / banner"), img("images.whyChoose", "Why choose us"), img("images.ctaBg", "CTA background"), img("images.pageBanner", "Default page banner"), img("images.arafat", "Arafat / Hajj CTA")] },
  { title: "Hajj Booking", fields: [num("hajj_deposit", "Registration deposit (BDT)"), ...bi("hajj_booking", "Booking note", "textarea"), ...bi("hajj_gifts", "Free gifts (one per line)", "lines")] },
];
